const constants = {
  VIEW_QUERY_PARAM: 'view',
  VIEW_STATE_KEY: 'viewState',
  DIRECT_LINK_PURPOSE: 'direct-link',
  EXPORT_LINK_PURPOSE: 'export',
  COPY_LINK_PURPOSE: 'copy-link',
  SAVED_TO_CLIPBOARD_SUCCESS_MESSAGE: 'Link copied to clipboard',
  SAVE_TO_CLIPBOARD_ERROR_MESSAGE: 'Error while saving the link',
  SHARE_VIEW_API_URL: '/api/share-view',
} as const;

export default constants;
